import React, { useEffect, useState } from "react";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import { Helmet } from "react-helmet";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./ln.scss";

// Admin'dagi CKEditor matnidagi qo'lda qo'yilgan bo'sh joylar (&nbsp;) dizaynni buzmasin
const cleanHtml = (html) =>
  (html || "").replace(/^(\s|&nbsp;)+/gm, "").replace(/(<p>)(\s|&nbsp;)+/g, "$1").replace(/<p>(\s|&nbsp;)*<\/p>/g, "");

function Ofer({ t }) {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const lang = useSelector((state) => state.langReducer.value);
  useEffect(() => {
    setLoading(true);
    axios(url.url + "/oferta", { headers: headers() })
      .then((res) => setData(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [lang]);

  return (
    <div className="ln ln-doc">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("Offer")}</title>
        <meta name="description" content={t("ln_offer_text")} />
      </Helmet>

      <div className="ln-doc__hero">
        <div className="ln-doc__wrap">
          <span className="ln-eyebrow">{t("ln_offer_eyebrow")}</span>
          <h1 className="ln-doc__title">{t("Offer")}</h1>
          <p className="ln-lead">{t("ln_offer_text")}</p>
        </div>
      </div>

      <div className="ln-doc__wrap ln-doc__body">
        <article className="ln-doc__card">
          {loading ? (
            <div className="ln-doc__skeleton">
              {[90, 70, 85, 60, 80].map((w, i) => (
                <span key={i} className="ln-skel" style={{ width: `${w}%` }} />
              ))}
            </div>
          ) : data?.data ? (
            <div className="ln-prose" dangerouslySetInnerHTML={{ __html: cleanHtml(data.data) }} />
          ) : (
            <p className="ln-lead">{t("No data")}</p>
          )}
        </article>

        <aside className="ln-doc__aside">
          <div className="ln-doc__box">
            <strong>{t("ln_offer_accept_title")}</strong>
            <p>{t("ln_offer_accept_text")}</p>
            <Link to="/register/frist-step" className="ln-btn ln-btn_primary">
              {t("Sign up")}
            </Link>
          </div>
          <div className="ln-doc__box">
            <strong>{t("ln_contact_title")}</strong>
            <p>{t("ln_contact_text")}</p>
            <Link to="/#contact" className="ln-btn ln-btn_outline">
              {t("Contact")}
            </Link>
          </div>
          <button type="button" className="ln-doc__print" onClick={() => window.print()}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 9V3h12v6M6 18H4a1 1 0 0 1-1-1v-6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1h-2" /><path d="M6 14h12v7H6z" /></svg>
            {t("ln_print")}
          </button>
        </aside>
      </div>
    </div>
  );
}
export default withTranslation()(Ofer);
